import { motion, AnimatePresence } from "motion/react"
import { APP_CONFIG } from "constants/constants";
import { memo, useEffect } from "react"

interface CoverProps {
    visible: boolean,
    onClose?: () => void,
    enableClickClose?: boolean,
    topClassName?: string,
    zClassName?: string
}

const Cover: React.FC<CoverProps> = ({ visible, onClose, enableClickClose = false, topClassName = "top-0", zClassName = "z-[110]" }) => {

    useEffect(() => {
        if (!visible) return
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === `Escape` && onClose) {
                onClose()
            }
        }
        document.addEventListener(`keydown`, handleKeyDown)
        return () => document.removeEventListener(`keydown`, handleKeyDown)
    }, [visible, onClose])

    return (
        <AnimatePresence>
            {visible && <motion.div
                className={`
                    fixed
                    ${topClassName}
                    left-0
                    right-0
                    bottom-0
                    ${zClassName}
                    bg-[rgba(0,0,0,0.6)]
                `}
                initial={{
                    opacity: 0
                }}
                animate={{
                    opacity: 1,
                    transition: {
                        duration: APP_CONFIG.SHORT_ENTER_ANIMATION_DURATION
                    }
                }}
                exit={{
                    opacity: 0,
                    transition: {
                        duration: APP_CONFIG.SHORT_EXIT_ANIMATION_DURATION
                    }
                }}
                onClick={enableClickClose ? onClose : undefined}
            ></motion.div>}
        </AnimatePresence>
    )
}

export default memo(Cover)
